import {Component, Input, OnInit, ElementRef, Renderer, HostBinding} from '@angular/core';

@Component({
  selector: '[kv-form-element]',
  template: `<label translate>{{ this.conf.label }}</label><ng-content></ng-content>`,
  providers: [],
})
export class FormElementComponent implements OnInit {

  @Input('kv-form-element') conf: FormElementConf;

  private el;


  constructor(el: ElementRef, public renderer: Renderer){
    this.el = el.nativeElement;

  }

  ngOnInit(): void {
    if (!this.conf.lg) {
      this.conf.lg = this.conf.md;
    }

    if (!this.conf.g) {
      this.conf.g = '12';
    }

    if (this.conf.required) {
      this.renderer.setElementClass(this.el, 'required', true);
    }

    this.renderer.setElementClass(this.el, 'ui-g-' + this.conf.md, true);
  }
}

export class FormElementConf {
  label: string;
  md: string;
  required?: boolean;
  g?: string;
  lg?: string;
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/formElement.component.ts